import {DisableMobileApplicationRequestStatusEnum} from '@/services/api-clients';
import i18n from '@/i18n/config';
import {LF} from '@/i18n/LF';

export function disableMobileApplicationRequestStatusNameFilter(status: DisableMobileApplicationRequestStatusEnum): string {
  switch (status) {
    case DisableMobileApplicationRequestStatusEnum.Pending: return i18n.t(LF.DisableMobileApplicationRequestStatusPending) as string;
    case DisableMobileApplicationRequestStatusEnum.Finished: return i18n.t(LF.DisableMobileApplicationRequestStatusFinished) as string;
  }
}
